import { render, staticRenderFns } from "./PropertyComment.vue?vue&type=template&id=5b21560c&scoped=true&"
import script from "./PropertyComment.vue?vue&type=script&lang=ts&"
export * from "./PropertyComment.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyComment.vue?vue&type=style&index=0&id=5b21560c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b21560c",
  null
  
)

export default component.exports